/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';

import { Partner } from '../constants';
import { PartnerField, PartnerStaticFieldMap } from '../models';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'partner-staticfield-picker',
  templateUrl: './partner-staticfield-picker.component.html'
})
export class PartnerStaticfieldPickerComponent implements OnInit {

  @Input()
  partner: Partner;

  @Input()
  fieldMap: Array<PartnerStaticFieldMap>;

  @Input()
  partnerFields: Array<PartnerField>;

  @Input()
  usedFields: Array<PartnerField>;

  @Output('onChange')
  onChange: EventEmitter<Array<PartnerStaticFieldMap>> = new EventEmitter<Array<PartnerStaticFieldMap>>();

  @Output('onRefreshFields')
  onRefreshFields: EventEmitter<any> = new EventEmitter<any>();

  // field drop down component
  ddFields: any[] = [];
  fieldDDSettings: any = {
    singleSelection: true,
    text: 'Select field',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    maxHeight: 260
  };
  ddField: any;

  fields: Array<PartnerField>;
  addingField: boolean = false;
  currentStaticValue: string = '';
  currentStaticField: PartnerField;
  errorState: boolean = false;

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {
    // if there are no fields mapped yet, initialize the array
    if (!this.fieldMap) {
      this.fieldMap = [];
    }

    if (this.partner) {
      this.loadFields();
    }
  }

  /**
   * Listen for changes to the partner value in order to properly refresh fields and re-set state
   * when switching from one partner to another
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.partner && changes.partner.previousValue &&  changes.partner.previousValue.name) {
      // Refresh state of field map controls when partner changes
      this.addingField = false;
      this.currentStaticValue = '';
      this.currentStaticField = null;
      this.errorState = false;
      this.loadFields();
    }
    else if (changes.usedFields) {
      // change triggers if usedFields changes across all field map controls - ensure fields can
      // only be selected once
      this.loadFields();
    }
  }

  formValid() {
    if (this.currentStaticField && this.currentStaticValue.length > 0) {
      return true;
    }
    return false;
  }

  selectField(field: any) {
    this.currentStaticField = this.fields.find((f) => f.id == field.id);
  }

  addField() {
    this.fieldMap.push({
      partnerField: this.currentStaticField,
      value: this.currentStaticValue
    });
    this.currentStaticValue = '';
    this.onChange.emit(this.fieldMap);
    this.addingField = false;
    this.loadFields(); // refresh from cache to set usedFields up correctly
  }

  cancelAddField() {
    this.addingField = false;
    this.currentStaticValue = '';
    this.currentStaticField = null;
    this.ddField = [];
  }

  remove(field: PartnerStaticFieldMap) {
    this.fieldMap.splice(this.fieldMap.findIndex((f) => f.partnerField.id == field.partnerField.id), 1);
    this.loadFields(); // refresh from cache to set usedFields up correctly
    this.onChange.emit(this.fieldMap);
  }

  refreshFields() {
    this.onRefreshFields.emit(null);
  }

  private loadFields() {
    this.fields = [];
    this.ddField = [];
    this.ddFields = [];
    this.partnerFields.forEach((f) => {
      // only make the field available if it hasn't been used
      if (this.usedFields.findIndex((uf) => uf.id == f.id) < 0 &&
          this.fieldMap.findIndex((uf) => uf.partnerField.id == f.id) < 0) {
        this.fields.push({
          id: f.id,
          name: f.name,
          display: f.display,
          type: f.type ? f.type : 'n/a'
        });

        this.ddFields.push({
          id: f.id,
          itemName: f.display
        });
      }
    });

    this.fields.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      else {
        return 1;
      }
    });

    this.ddFields.sort((a, b) => {
      if (a.itemName < b.itemName) {
        return -1;
      }
      else {
        return 1;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/global/partner-staticfield-picker/partner-staticfield-picker.component.ts